import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { DELETE_PAYMENT_CARD_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import { LIST_CARDS } from './getListCards';
import type { DeleteCardRequestPayload, DeleteCardResult } from '../types/deleteCard.types';

export const deleteCard = (builder: BuilderType) =>
  builder.mutation<DeleteCardResult, DeleteCardRequestPayload>({
    invalidatesTags: [LIST_CARDS],
    query: (params) => ({
      data: params,
      isErrMsgConcatErrCode: false,
      method: 'POST',
      url: DELETE_PAYMENT_CARD_URL,
    }),
    transformResponse: (response: GenericApiResponse<DeleteCardResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }
      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
